export function generateMagicCode(inputString, sourceString) {
    return calculateCode(inputString);
}

function normalizeString(inputString, logs) {
    const vowels = 'аеёиоуыэюя'; 
    let digitsOutput = '';
    let vowelsOutput = '';
    let vowelsString = '';
    let vowelsPositions = {};
    for (let i = 0; i < inputString.length; i++) {
        const char = inputString[i];
        if (vowels.includes(char) /*&& !(char.toLowerCase() in vowelsPositions)*/) {
            //vowelsPositions[char.toLowerCase()] = i + 1;
            vowelsOutput += char;
            vowelsString += char;
        } else {
            vowelsString += "&nbsp;";
        }
        
    }

    for (let i = 0; i < inputString.length; i++) {
        const char = inputString[i];
        if (isNaN(char)) {
            digitsOutput += `${symbolToNumber(char.toLowerCase())}`;
        }
        else {
            digitsOutput += char
        }
    }
    
    logs.push('<b>Оцифрование:</b> ' + digitsOutput);
    if (vowelsOutput) {
        logs.push('<b>Гласные:</b> &nbsp;&nbsp;&nbsp;&nbsp;' + vowelsString);
    }
    return {digits: digitsOutput, vowels: vowelsOutput}
}

export function generateNumbersCode(inputString, sourceString) {
    const logs = [];
    const spaceIndices = [];
    let currentIndex = -1;
    while ((currentIndex = sourceString.indexOf(' ', currentIndex + 1)) !== -1) {
        spaceIndices.push(currentIndex);
    }
    logs.push('<b>Ввод:</b>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + sourceString.replace(/\s+/g, ''));
    const digits = normalizeString(inputString, logs).digits;
    //console.log(digits)
    return sumCode(digits, sourceString, logs);
}

function sumCode(digitsString, sourceString, logs) {
    let tempDigital = digitsString;
    //logs.push('<b>Оцифрование:</b> ' + tempDigital);
    logs.push('<b>Cумма:<b> ')
    while (tempDigital.length !== 1) {
        let resultNumbers = 0;
        let str = ''
        Array.from(tempDigital).forEach((element, index) => {
            
            if (tempDigital.length-1 > index) {
                str += `${element} + `
            } else {
                str += `${element}`
            }
            resultNumbers += Number(element);
        });
        
        tempDigital = String(resultNumbers);
        logs.push(str + ` = ${tempDigital}`);
    }
    let soundString = sound(sourceString, logs);
    return {
        logs: logs,
        sum: tempDigital, 
        soundString: soundString
    };
}

function sound(sourceString, logs) {
    const isOnlyNumbers = /^[0-9\s]+$/.test(sourceString);
    if (!isOnlyNumbers) {
        return null;
    }
    const mapSound = new Map([
        ['1', 'Аисъ'],
        ['2', 'Бйты'],
        ['3', 'Вкуь'],
        ['4', 'Глфэ'],
        ['5', 'Дмхю'],
        ['6', 'Енця'],
        ['7', 'Ёоч'],
        ['8', 'Жпш'],
        ['9', 'Зрщ'],
        ['0', ''],
        [' ', '']
    ]);
    let soundsString = Array.from(sourceString).reduce((acc, item, index) => {
        return acc + mapSound.get(item);
    }, '')
    logs.push('<b>Звуковой ряд:</b><br>' + soundsString);
    return soundsString;
}

function symbolToNumber(char) {
    const table = [
        ['а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з'],
        ['и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р'],
        ['с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
        ['ъ', 'ы', 'ь', 'э', 'ю', 'я']
    ];

    let findIndex;
    for (let i = 0; i < table.length; i++) {
        let index = table[i].indexOf(char);
        if (index !== -1) {
            findIndex = index + 1;
        }
    }
    return findIndex;
}

function calculateCode(inputString) {
    let logs = [`<b>Ввод:</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${inputString}`];
    const normalizeData = normalizeString(inputString, logs);
    //logs.push(`<b>Оцифрование:</b> ${normalizeData.digits}`);

    let numbers = normalizeData.digits.split('').map(Number);

    function sumPairs(array) {
        let result = [];
        for (let i = 0; i < array.length; i += 2) {
            if(array[i + 1]) {
                result.push(array[i] + array[i + 1]);
            }
            else {
                result.push(array[i]);
            }
            
        }
        return result;
    }

    while (numbers.join('').replace('0', '').length !== 9) {
        if (numbers.join('').length < 9) {
            numbers.push(3,6,9);
            logs.push(`<b>Добавляем 369:</b> ${numbers.join(' ')}`);
        }
        else {
            logs.push(`<b>Складываем числа по парам:</b>`);
            const after_sum_numbers = sumPairs(numbers);
            let log_table = '<table>';
            let log_table_row_before_sum = '<tr>';
            let log_table_row_pointers = '<tr>';
            let log_table_row_after_sum = '<tr>';
            after_sum_numbers.forEach((item, index, arr) => {
                const b_index = index * 2;
                log_table_row_before_sum += `<td>${numbers[b_index]} ${numbers[b_index+1] ?? '' }</td>`;
                log_table_row_pointers += numbers[b_index+1] != undefined ? '<td>\\/</td>' : '<td>|</td>';
                log_table_row_after_sum += `<td>${item}</td>`;
            });
            log_table += log_table_row_before_sum + log_table_row_pointers + log_table_row_after_sum + '</table>';
            logs.push(log_table);
            numbers = after_sum_numbers;
        }
    }
    
    let result = numbers.join('')
    if(result.indexOf(0)!== -1) {
        logs.push('<b>Особенный случай:</b> 10 цифр, из них один ноль. Убираем ноль.');
        result = result.replace('0', '');
    }
    logs.push('<b>Результат:</b> ', splitStringByNChars(result, 3))
    return logs;
}

function splitStringByNChars(s, n) {
    let result = '';
    for (let i = 0; i < s.length; i += n) {
        result += s.substr(i, n) + ' ';
    }
    return result.trim(); 
}


